import useAxios from '../hooks/useAxios';
import useAxiosResponse from '../hooks/useAxiosResponse';
import EnvironmentContextInterface from '../contexts/EnvironmentContext/EnvironmentContextInterface';
import { AxiosError } from 'axios';

export const useServerConfig = (
  url = 'config.json'
): [EnvironmentContextInterface | undefined, AxiosError | undefined, boolean] => {
  const fetchData = useAxios({ url, method: 'get' });
  const [{ response, error, loading: axiosLoading }] =
    useAxiosResponse<EnvironmentContextInterface>(fetchData);
  const loading = axiosLoading || !response;

  return [response, error, loading];
};

export default useServerConfig;
